export default __webpack_public_path__ + "static/media/fact_sheet26.77ba6a86.png";